import React from 'react';
import {
  Container,
  Alert,
  Row,
} from 'react-bootstrap';
import { Navigate } from 'react-router-dom';

export default function UserAuthRequired(props) {
  if (props.redirectToLogin) {
    // redirect to login and preserve current URL in location.state.from
    const current = window.location.pathname + window.location.search + window.location.hash;
    return <Navigate to={`/service/user/login`} replace state={{ from: current }} />
  }

  return (
    <Container fluid>            
      <Row style={{ marginTop: "15px" }}> 
        {props.notallowed && (
          <Alert key="warning" variant="warning">
            You are not allowed to access this page!
          </Alert>
        )}
        {props.notlogged && (
          <Alert key="danger" variant="danger">
            You must be logged in to the server!
          </Alert>
        )}
        {props.text && (
          <Alert key="info" variant="info">
            {props.text}
          </Alert>
        )}
      </Row>
    </Container>
  )
  }
